<template>
  <aside class="DashboardNavigation">
    <router-link
      :to="{ name: 'MyHub' }"
      class="Account-secondaryMenuLink"
      data-cy-id="sidebar-my-hub"
    >
      <span class="Account-navIcon far fa-columns" />
      <span class="Account-secondaryLabel">My Hub</span>
    </router-link>

    <router-link
      :to="{ name: 'SavedItems' }"
      :class="{'active-link': $route.path.indexOf('saved-items') > -1}"
      class="Account-secondaryMenuLink Account-secondaryMenuLink--company"
      data-cy-id="sidebar-saved-items"
    >
      <span class="Account-navIcon far fa-heart" />
      <span class="Account-secondaryLabel">Saved Items</span>
    </router-link>

    <!-- TODO readd saved searches  -->

    <router-link
      :to="{ name: 'reviews' }"
      class="Account-secondaryMenuLink"
    >
      <span class="Account-navIcon far fa-star-half-alt" />
      <span class="Account-secondaryLabel">My Reviews</span>
    </router-link>

    <router-link
      :to="{ name: 'contact-preferences' }"
      class="Account-secondaryMenuLink"
    >
      <span class="Account-navIcon far fa-envelope-open-text" />
      <span class="Account-secondaryLabel">Contact Preferences</span>
    </router-link>

    <router-link
      :to="{ name: 'basic-info' }"
      :class="{'active-link': $route.path.indexOf('personal-information') > -1}"
      class="Account-secondaryMenuLink"
      data-cy-id="sidebar-personal-info"
    >
      <span class="Account-navIcon far fa-user-cog" />
      <span class="Account-secondaryLabel">Personal Info</span>
    </router-link>
    <router-link
      :to="{ name: 'data-security' }"
      class="Account-secondaryMenuLink"
      data-cy-id="sidebar-data-security"
    >
      <span class="Account-navIcon far fa-lock" />
      <span class="Account-secondaryLabel">Data & Security</span>
    </router-link>
  </aside>
</template>
<script>
export default {

};
</script>

<style lang="scss" scoped>
@import "../../../../scss/abstracts/abstracts";

.DashboardNavigation {
  @include respond-to(md) {
    display: block;
    flex-basis: 25%;
    flex-shrink: 1;
    padding-right: 20px;
    padding-left: 10px;

  a {
    color:color('grey', 'dark');
    width: 100%;

    &.router-link-active, &.active-link {
      color: color($primary-color);
      border: 1px solid #d3d3d3;
      background-color: #ffffff;
    }
  }
}
}
</style>
